if (!customElements.get('affiliate-page')) {
  customElements.define(
    'affiliate-page',
    class AffiliatePage extends HTMLElement {
      #affiliatePartner;
      #formData;

      constructor() {
        super();
        this.#affiliatePartner = window.affiliate_partner;
        this.scrollBtn = this.querySelector('.ap-button');

        if (this.scrollBtn) {
          this.scrollBtn.addEventListener('click', (e) => {
            e.preventDefault();
            const target = this.querySelector('#hero_product');
            if (target) {
              target.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
              });
            }
          });
        }
      }

      connectedCallback() {
        const init = () => {
          if (!this.#affiliatePartner || window.cart_affiliate === this.#affiliatePartner) {
            return;
          }

          this.#formData = new FormData();
          this.#formData.append('attributes[affiliate]', this.#affiliatePartner || '');

          fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            body: this.#formData,
          })
            .then(() =>
              fetch(
                `${routes.cart_url}?sections=cart-drawer,cart-icon-bubble,main-cart-footer,main-cart-items`,
              ),
            )
            .then((response) => response.json())
            .then((sections) => {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'affiliate-update',
                cartData: {
                  sections,
                },
              });
            })
            .catch(console.error);
        };

        document.readyState === 'loading'
          ? document.addEventListener('DOMContentLoaded', init, { once: true })
          : init();
      }
    },
  );
}
